import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Button, ButtonProps, LoadingIndicator } from '@cfa/react-core';
import { themeSizes } from '../../styles/globalStyleVars';

const StyledLoadingButton = styled(Button)`
  &[data-pending] {
    background-color: var(--cfa-color-disabled-base);
    border-color: var(--cfa-color-disabled-base);
    color: var(--cfa-color-disabled-contrast);
    cursor: default;
  }
`;

const PendingContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${themeSizes.sm};
`;

type LoadingButtonProps = Omit<ButtonProps, 'children'> & {
  children?: ReactNode;
};

export const LoadingButton: FC<LoadingButtonProps> = ({
  isPending,
  children,
  ...rest
}) => (
  <StyledLoadingButton isPending={isPending} {...rest}>
    {isPending ? (
      <PendingContent>
        <LoadingIndicator size='sm' isDisabled />
        {children}
      </PendingContent>
    ) : (
      children
    )}
  </StyledLoadingButton>
);
